import { render, staticRenderFns } from "./SalaryPayInfo.vue?vue&type=template&id=618840a2&scoped=true&"
import script from "./SalaryPayInfo.vue?vue&type=script&lang=js&"
export * from "./SalaryPayInfo.vue?vue&type=script&lang=js&"
import style0 from "./SalaryPayInfo.vue?vue&type=style&index=0&id=618840a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618840a2",
  null
  
)

export default component.exports